(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/lobby/lobby.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/lobby/lobby.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useContext = _React.useContext,
  useState = _React.useState,
  useRef = _React.useRef,
  useMemo = _React.useMemo;
const Lobby = () => {
  const _svs$eInstant$shared$ = svs.eInstant.shared.components,
    InfoOverlay = _svs$eInstant$shared$.InfoOverlay,
    Background = _svs$eInstant$shared$.Background,
    TicketsRowWrapper = _svs$eInstant$shared$.TicketsRowWrapper;
  const _useContext = useContext(svs.eInstant.store.RouterContext),
    _useContext$state = _useContext.state,
    gameUrl = _useContext$state.gameUrl,
    _useContext$state$cat = _useContext$state.categories,
    initialCategories = _useContext$state$cat === void 0 ? [] : _useContext$state$cat;
  const LOBBY = svs.eInstant.constants.ROUTES.LOBBY;
  const WidgetArea = svs.eInstant.lobby.WidgetArea;
  const _svs$eInstant$shared$2 = svs.eInstant.shared.hooks.useMetaTags(),
    update = _svs$eInstant$shared$2.update;
  const validateGameConfig = svs.eInstant.util.validateGameConfig;
  const Loader = svs.eInstant.components.Loader;
  const wrapperRef = useRef(null);
  const _svs$eInstant$shared$3 = svs.eInstant.shared.hooks.useScrollPosition({
      element: wrapperRef
    }),
    scrollToPosition = _svs$eInstant$shared$3.scrollToPosition;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isContentVisible = _useState2[0],
    setIsContentVisible = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    heroWidgetLoaded = _useState4[0],
    setHeroWidgetLoaded = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    lobbyWidgetLoaded = _useState6[0],
    setLobbyWidgetLoaded = _useState6[1];
  const categories = useMemo(() => (initialCategories || []).map(category => _objectSpread(_objectSpread({}, category), {}, {
    games: category.games.filter(g => validateGameConfig(g)).slice(0, 8)
  })).filter(_ref => {
    let _ref$games = _ref.games,
      games = _ref$games === void 0 ? [] : _ref$games;
    return (games === null || games === void 0 ? void 0 : games.length) > 0;
  }).map(category => React.createElement("div", {
    className: "margin-v-3",
    key: category.urlPath
  }, React.createElement(TicketsRowWrapper, {
    category: category
  }))), [initialCategories]);
  useEffect(() => {
    !gameUrl && update(LOBBY);
  }, [gameUrl]);
  useEffect(() => {
    if (heroWidgetLoaded && lobbyWidgetLoaded) {
      setIsContentVisible(true);
      scrollToPosition();
    }
  }, [heroWidgetLoaded, lobbyWidgetLoaded]);
  return React.createElement(React.Fragment, null, !isContentVisible && React.createElement(Loader, null), React.createElement(InfoOverlay, null), React.createElement("div", {
    className: "js-e-instant lobby-page relative ".concat(isContentVisible ? 'content-visible' : 'content-hidden', " tickets-einstant-ribbon-theme"),
    ref: wrapperRef
  }, React.createElement(WidgetArea, {
    areaName: "hero",
    className: "full-width-widget overlapped overlap-padding",
    onLoaded: setHeroWidgetLoaded
  }), React.createElement(Background, {
    classNames: "tickets-einstant-lobby-container"
  }, React.createElement("div", {
    className: "lobby-category-container tickets-einstant-max-width"
  }, categories), React.createElement(WidgetArea, {
    areaName: "lobby",
    className: "u-text-left widget-default-margin-top-0 widget-area-e-instant-lobby",
    onLoaded: setLobbyWidgetLoaded
  }))));
};
setGlobal('svs.eInstant.lobby.Lobby', Lobby);

 })(window);